export default {
  data() {
    return {
      tableData: [{
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-08',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-06',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-07',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }],
      reportList: {
        type: "",
        people: "",
        time: "",
        title: "",
        content: "",

      },
      value3: "",
      ruleForm: {
        //...省略其他
        articleBody: '',
      },
      rules: {
        //..省略其他
        articleBody: [
          { required: true, message: '请输入文本', trigger: 'change' }
        ],
      },
      editorOption:{//富文本配置
        placeholder: '请输入内容',
      }



    }
  },
  mounted() {

  },
  methods: {
    //点击消息详情
    handelDetails() {
      this.activeName = "message"
    },
    //点击标签页
    handleClick() {

    },
    //点击消息历史的详情
    handelCustomizeDetails() {
      // this.$router.push(`/subscribeDetails`)
      this.activeName = "message"
    }

  }
}